import { Button, Input, notification, Icon } from "antd";
import React from "react";
import api from "../../../../../services/api";
import { isSuperUser } from "../../../../../utils/is-superuser";

export function NumeroClienteField({ acordoId, value }) {
  const [isEditing, setEditing] = React.useState(false);
  const [isSaving, setSaving] = React.useState(false);
  const [inputValue, setInputValue] = React.useState(value);

  const toggleEdit = () => setEditing(!isEditing);

  const handleSave = () => {
    setSaving(true);

    api
      .post("/acordo/update-numero-cliente/", {
        acordo_id: acordoId,
        numero_cliente: inputValue
      })
      .then(() => {
        setEditing(false);
        setSaving(false);
        notification.success({
          message: "Número cliente atualizado com sucesso."
        });
      })
      .catch(() => {
        setSaving(false);
        notification.error({
          message: "Falha ao salvar número cliente"
        });
      });
  };

  const handleInputChange = event => setInputValue(event.target.value);
  const isAdmin = isSuperUser();

  return (
    <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
      <Input
        size="small"
        disabled={!isEditing}
        placeholder="Vazio"
        onChange={handleInputChange}
        value={inputValue}
        style={{ width: '120px' }}
      />
      {isAdmin && (
        <React.Fragment>
          {isEditing ? (
            <Button
              size="small"
              type="primary"
              onClick={handleSave}
              disabled={isSaving}
              icon="check"
            />
          ) : (
            <Button
              size="small"
              icon="edit"
              type="link"
              onClick={toggleEdit}
            />
          )}
        </React.Fragment>
      )}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/Pasta/Acordos/AcordoView/AcordoInfos/NumeroClienteField.jsx